import { DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { Dialog } from '@mui/material';
import React, { useState } from 'react';
import CustomButton from '../../../../../../../../../../../../lib/designSystem/Button';
import { showAlert } from '../../../../../../../../../../../../lib/functions/utils';
import { deleteMultipleCollectionManagement } from '../../../../../../../../../../../../lib/api/collections';
import { useDispatch } from 'react-redux';
import CenteredCircularProgress from '../../../../../../../../../../../../lib/designSystem/CircularProgress';
import EnhancedTable from '../../../../../../../../../../../../lib/designSystem/Table';

const MultiDelete = (props: any) => {
  const { open, setOpen, managementsToDelete } = props;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const handleConfirmDelete = async () => {
    setLoading(true);
    try {
      const dataForRequest = {
        managements: managementsToDelete.map(
          (management: any) => management.id,
        ),
      };
      await deleteMultipleCollectionManagement(dispatch, dataForRequest);
      showAlert(dispatch, 'success', 'Gestiones eliminadas correctamente');
      window.location.reload();
    } catch (error) {
      showAlert(dispatch, 'error', 'Error al eliminar las gestiones');
    }
    setLoading(false);
  };

  return (
    <div>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="xl">
        <DialogTitle>
          ¿Estas seguro de eliminar las siguientes gestiones?
        </DialogTitle>
        <DialogContent>
          {loading ? (
            <div style={{ minHeight: '100px' }}>
              <CenteredCircularProgress type="dialog" />
            </div>
          ) : (
            <div style={{ marginTop: '20px' }}>
              <EnhancedTable
                dataHeaders={[
                  { key: 'id', label: 'ID', type: 'numeric-id' },
                  {
                    key: 'elementType',
                    label: 'Tipo',
                    type: 'collection-type',
                  },
                  { key: 'description', label: 'Descripción' },
                  { key: 'folio', label: 'Documento' },
                  {
                    key: 'businessName',
                    label: 'Cliente',
                  },
                  {
                    key: 'stakeholderName',
                    label: 'Deudor',
                  },
                  { key: 'dueDate', label: 'Fecha gestión', type: 'due-date' },
                ]}
                data={managementsToDelete}
                rowsPerPageDefault={10}
              />
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <CustomButton color="secondary" onClick={() => setOpen(false)}>
            Cancelar
          </CustomButton>
          <CustomButton color="error" onClick={() => handleConfirmDelete()}>
            Confirmar
          </CustomButton>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default MultiDelete;
